import "./contact.scss";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const Contact = () => {
  return (
    <div className="contact" id="contact">
      <a
        href="https://www.linkedin.com/in/roberto-carro/"
        target="_blank"
        rel="noreferrer"
      >
        <LinkedInIcon className="icon" />
      </a>
      <a
        href="https://github.com/robcg1102"
        target="_blank"
        rel="noreferrer"
      >
        <GitHubIcon className="icon" />
      </a>
    </div>
  );
};
